import { ColorPickerField } from '../../components/ColorPickerField';
import { IconField } from '../../components/IconField';
import EmergencyElemTitle from './EmergencyElemTitle';

// use a type here, not an interface
// type Data = {
//   title: string,
//   style: {
//     iconBackground: string;
//     icon: string;
//     padding: number;
//     iconColor: string;
//     bgColor: string;
//     textColor: string;
//   };
// }

const emergencyElemTitlePlugin: any = {
  Renderer: ({ data }: any) => (
    <EmergencyElemTitle
      title={data?.title}
      padding={data?.style?.padding}
      iconBackground={data?.style?.iconBackground}
      icon={data?.style?.icon}
      iconColor={data?.style?.iconColor}
      bgColor={data?.style?.bgColor}
      textColor={data?.style?.textColor}
    />
  ),
  id: 'emergencyElemTitle',
  title: 'Title Box',
  // description: 'Emergency title with an icon',
  version: 1,
  controls: [
    {
      title: 'Default Config',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            title: {
              type: 'string',
              default: 'Title',
            },
          },
          required: ['title'],
        },
      },
    },
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                padding: {
                  type: 'number',
                  default: 20,
                },
                icon: {
                  type: 'string',
                  default: 'Anchor 2',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    // you can pass additional props to uniforms, e.g. the component to use to render the field
                    component: ColorPickerField,
                    label: 'Icon Background: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: "'rgba(34,34,34,1)'",
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
                bgColor: {
                  type: 'string',
                  default: 'rgba(238, 89, 97,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Background Color: ',
                  },
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default emergencyElemTitlePlugin;
